const SvgChevronRight = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="m19.057 16-7.528-7.528.943-.943L20.943 16l-8.471 8.472-.943-.943z" />
  </svg>;
export default SvgChevronRight;